(function () {
  var TIERS = null;
  var bundleHandles = { 'one-of-each-1': true };
  var initialized = false;

  function parseTiers() {
    var card = document.getElementById('CartDrawer-ProgressCard');
    if (!card) return false;

    var raw = card.getAttribute('data-tiers');
    if (!raw) return false;

    try {
      TIERS = JSON.parse(raw);
    } catch (e) {
      return false;
    }
    if (!TIERS || !TIERS.length) return false;

    var bundleHandlesRaw = (card.getAttribute('data-bundle-handles') || '').trim();
    if (bundleHandlesRaw) {
      bundleHandlesRaw.split(',').forEach(function (h) {
        h = h.trim();
        if (h) bundleHandles[h] = true;
      });
    }

    return true;
  }

  function isBundle(item) {
    if (bundleHandles[item.handle]) return true;
    if (item.product_type && /bundle/i.test(item.product_type)) return true;
    if (item.properties && item.properties._bundle) return true;
    return false;
  }

  function updateTierUI(fullSubtotal, nonBundleSubtotal) {
    var c = document.getElementById('CartDrawer-ProgressCard');
    if (!c || !TIERS || !TIERS.length) return;

    var textEl = c.querySelector('[data-cart-tier-text]');
    var dots = c.querySelectorAll('[data-cart-tier-dot]');
    var lines = c.querySelectorAll('[data-cart-tier-line]');
    if (!textEl) return;

    var points = [0];
    TIERS.forEach(function (t) { points.push(t.threshold); });

    dots.forEach(function (dot, i) {
      if (!TIERS[i]) return;
      var sub = TIERS[i].includesBundles !== false ? fullSubtotal : nonBundleSubtotal;
      dot.classList.toggle('cart-drawer__progress-dot--empty', sub < TIERS[i].threshold);
    });

    lines.forEach(function (line, i) {
      if (!TIERS[i]) return;
      var sub = TIERS[i].includesBundles !== false ? fullSubtotal : nonBundleSubtotal;
      var segStart = points[i];
      var segEnd = points[i + 1];
      if (sub >= segEnd) {
        line.classList.add('cart-drawer__progress-line--filled');
        line.style.cssText = '';
      } else if (sub > segStart) {
        var pct = Math.min(((sub - segStart) / (segEnd - segStart)) * 100, 100);
        line.classList.remove('cart-drawer__progress-line--filled');
        line.style.cssText = 'background: linear-gradient(to right, #8B89B1 ' + pct + '%, #DDDCE8 ' + pct + '%) !important;';
      } else {
        line.classList.remove('cart-drawer__progress-line--filled');
        line.style.cssText = '';
      }
    });

    var highestReached = null;
    for (var i = TIERS.length - 1; i >= 0; i--) {
      var sub = TIERS[i].includesBundles !== false ? fullSubtotal : nonBundleSubtotal;
      if (sub >= TIERS[i].threshold) {
        highestReached = TIERS[i];
        break;
      }
    }

    var nextTier = null;
    for (var j = 0; j < TIERS.length; j++) {
      var sub2 = TIERS[j].includesBundles !== false ? fullSubtotal : nonBundleSubtotal;
      if (sub2 < TIERS[j].threshold) {
        nextTier = TIERS[j];
        break;
      }
    }

    if (!nextTier && highestReached) {
      textEl.innerHTML = highestReached.applied || (highestReached.reward + ' applied!');
    } else if (nextTier) {
      var effectiveSub = nextTier.includesBundles !== false ? fullSubtotal : nonBundleSubtotal;
      var remaining = nextTier.threshold - effectiveSub;
      var rem = remaining % 1 === 0 ? '$' + remaining : '$' + remaining.toFixed(2);
      textEl.innerHTML = 'Add ' + rem + ' for ' + nextTier.reward;
    }
  }

  function fetchAndRender() {
    if (!TIERS) parseTiers();
    if (!TIERS || !TIERS.length) return;

    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true);
    xhr.onload = function () {
      if (xhr.status === 200) {
        try {
          var cart = JSON.parse(xhr.responseText);
          var fullCents = 0;
          var nonBundleCents = 0;
          if (cart.items && cart.items.length) {
            cart.items.forEach(function (item) {
              var linePrice = item.final_line_price || (item.final_price * item.quantity);
              fullCents += linePrice;
              if (!isBundle(item)) {
                nonBundleCents += linePrice;
              }
            });
          } else {
            fullCents = cart.items_subtotal_price || cart.total_price || 0;
            nonBundleCents = fullCents;
          }
          updateTierUI(fullCents / 100, nonBundleCents / 100);
        } catch (e) {}
      }
    };
    xhr.send();
  }

  function setup() {
    if (initialized) return;
    if (!parseTiers()) return;
    initialized = true;

    fetchAndRender();

    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          setTimeout(fetchAndRender, 400);
        });
      }
    } catch (e) {}

    document.addEventListener('cart:refresh', function () {
      setTimeout(fetchAndRender, 400);
    });
  }

  window.__cartTierUpdate = fetchAndRender;

  function trySetup() {
    setup();
    if (!initialized) setTimeout(trySetup, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trySetup);
  } else {
    trySetup();
  }

  setInterval(function () {
    if (!initialized) setup();
    fetchAndRender();
  }, 2000);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) fetchAndRender();
  });
})();
